define(function(require){
	'use strict';

	var Marionette 	= require('marionette');
    var LPTModel    = require('vendor/Backbone/LPTModel');
    var AppConfig   = require("config/application");

	return LPTModel.extend({
		urlRoot : function(){ 
            return AppConfig.host + '/rest/notes';
            // return '/server/rest.php?rest=/rest/notes&forceauth=5316';
        },
	});
});